import React from 'react';
import { Settings2, User, Shield, Server, CheckCircle2 } from 'lucide-react';
import Cookies from 'js-cookie';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8001';

const Settings = () => {
  const adminName = Cookies.get('adminname') || Cookies.get('username') || 'Super Admin';
  const adminRole = Cookies.get('role') || 'SuperAdmin';
  const adminEmail = Cookies.get('email') || '';

  const card = 'bg-white border border-slate-100 rounded-2xl p-6 shadow-sm mb-5';
  const sectionTitle = 'text-base font-bold text-slate-800 flex items-center gap-2 mb-5';

  return (
    <div className="content-section">
      <div className="content-header" style={{ marginBottom: '1.5rem' }}>
        <div>
          <h1>Settings</h1>
          <p className="text-xs text-slate-400 font-medium mt-1">Super Admin profile and system details</p>
        </div>
      </div>

      {/* Admin Profile Card */}
      <div className={card}>
        <h2 className={sectionTitle}>
          <Settings2 size={18} style={{ color: '#0d9488' }} />
          Admin Profile
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1.25rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '1.25rem', background: '#f8fafc', borderRadius: '0.875rem', border: '1px solid #e2e8f0' }}>
            <div style={{ width: 52, height: 52, borderRadius: '0.875rem', background: 'linear-gradient(135deg,#0d9488,#0891b2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 900, fontSize: '1.4rem', flexShrink: 0 }}>
              {(adminName || 'S')[0].toUpperCase()}
            </div>
            <div>
              <div className="text-sm font-bold text-slate-800">{adminName}</div>
              <div className="text-xs text-slate-500">{adminEmail || 'admin@opmanagement.com'}</div>
              <span className="text-[11px] font-bold px-2 py-0.5 rounded-full mt-1 inline-block" style={{ background: '#fdf4ff', color: '#9333ea' }}>{adminRole}</span>
            </div>
          </div>

          <div style={{ padding: '1.25rem', background: '#f0fdf4', borderRadius: '0.875rem', border: '1px solid #bbf7d0' }}>
            <div className="text-xs text-slate-500 font-medium mb-1.5 flex items-center gap-1.5">
              <Shield size={14} className="text-emerald-600" />
              Session Status
            </div>
            <div className="flex items-center gap-2">
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#10b981', display: 'inline-block' }} />
              <span className="text-sm font-bold text-emerald-700">Active</span>
            </div>
            <div className="text-xs text-slate-400 mt-1">Authenticated with Bearer token</div>
          </div>

          <div style={{ padding: '1.25rem', background: '#eff6ff', borderRadius: '0.875rem', border: '1px solid #bfdbfe' }}>
            <div className="text-xs text-slate-500 font-medium mb-1.5 flex items-center gap-1.5">
              <Server size={14} className="text-blue-600" />
              API Server
            </div>
            <div className="text-xs font-mono font-bold text-blue-700 break-all">{API_BASE_URL}</div>
            <div className="text-xs text-slate-400 mt-1">Status: Online</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
